import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import TariffCreatePage from '../../../components/Pages/Tariffs/Create';

const { displayName } = config;

export default function TariffsCreate(): React.ReactNode | null {
  document.title = `${displayName}: Tariffs Create`;

  return (
    <Layout
      title="Tariffs create"
    >
      <TariffCreatePage />
    </Layout>
  );
}
